import { render, staticRenderFns } from "./ModalListaAyunta.vue?vue&type=template&id=4b69fe79&scoped=true&"
import script from "./ModalListaAyunta.vue?vue&type=script&lang=js&"
export * from "./ModalListaAyunta.vue?vue&type=script&lang=js&"
import style0 from "./ModalListaAyunta.vue?vue&type=style&index=0&id=4b69fe79&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b69fe79",
  null
  
)

export default component.exports